import Layout from "@/components/Layout";
import { motion } from "framer-motion";
import { Link } from "wouter";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <section className="bg-[#FFFDF7] min-h-[80vh] flex items-center justify-center py-20">
        <div className="max-w-lg mx-auto px-4 sm:px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* 404 Number */}
            <div className="border-3 border-[#0A1A3F] bg-white inline-block px-8 py-4 shadow-[6px_6px_0_0_#0A1A3F] mb-8">
              <span className="text-7xl sm:text-8xl font-black text-[#0A1A3F]">
                4<span className="text-[#6B8AFE]">0</span>4
              </span>
            </div>

            <h1 className="text-2xl sm:text-3xl font-black text-[#0A1A3F] mb-4">
              Sayfa Bulunamadı
            </h1>

            <p className="text-[#0A1A3F]/60 text-lg mb-8">
              Aradığınız sayfa mevcut değil veya taşınmış olabilir.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/"
                className="brutalist-btn bg-[#6B8AFE] text-white inline-flex items-center justify-center gap-2"
              >
                <Home size={18} />
                Ana Sayfaya Dön
              </Link>
              <button
                onClick={() => window.history.back()}
                className="brutalist-btn bg-white text-[#0A1A3F] inline-flex items-center justify-center gap-2"
              >
                <ArrowLeft size={18} />
                Geri Git
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
